import React, { useState } from 'react';

import {
  Typography, makeStyles, createStyles, Box,
} from '@material-ui/core';
import { useQuery, useMutation } from '@apollo/client';
import cx from 'classnames';
import { useHistory } from 'react-router';
import Page from '../page/Page';
import CatalogGenerator from './components/CatalogGenerator';
import GET_ALL_CATALOG_SPECS from '../../commons/gql/remote/catalogspecs/GetAllCatalogSpecs';
import GET_PRICESHEETS from '../../commons/gql/remote/pricesheets/GetPricesheets';
import GET_ALL_CATALOG_LOG_ITEMS from '../../commons/gql/remote/catalogs/GetCatalogLogItems';
import GENERATE_CATALOG from '../../commons/gql/remote/catalogs/GenerateCatalog';
import CREATE_CATALOG_SPEC from '../../commons/gql/remote/catalogspecs/CreateCatalogSpec';
import CatalogList from './components/CatalogList';
import CatalogPreviewDialog from './components/CatalogPreviewDialog';
import CreateCatalogSpecDialog from './components/CreateCatalogSpecDialog';
import CatalogSpecList from './components/CatalogSpecList';

const useStyles = makeStyles(() => createStyles({
  header: {
    paddingTop: '3rem',
    paddingBottom: '2rem',
  },
  inline: {
    display: 'inline-block',
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));

const CatalogsPage = () => {
  const history = useHistory();
  const classes = useStyles();
  const [openUrl, setOpenUrl] = useState<string>();
  const [isCreateCatalogDialogVisible, setCreateCatalogDialogVisible] = useState(false);
  const { data: catalogs, loading: loadingCatalog } = useQuery(GET_ALL_CATALOG_SPECS);
  const { data: pricesheets, loading: loadingPricesheet } = useQuery(GET_PRICESHEETS);

  const {
    data: catalogLogItems, loading: loadingCatalogLogItems,
  } = useQuery(GET_ALL_CATALOG_LOG_ITEMS);
  const [generateCatalog] = useMutation(GENERATE_CATALOG, {
    refetchQueries: [
      { query: GET_ALL_CATALOG_LOG_ITEMS },
    ],
  });
  const [createCatalogSpec] = useMutation(CREATE_CATALOG_SPEC, {
    refetchQueries: [{ query: GET_ALL_CATALOG_SPECS }],
    onCompleted: () => {
      setCreateCatalogDialogVisible(false);
    },
  });

  if (loadingCatalog || loadingPricesheet || loadingCatalogLogItems) return <Page>Loading...</Page>;

  return (
    <Page>
      <Typography variant="h3" className={classes.header}>Catalogs</Typography>
      <Box>
        <Typography variant="h5" className={classes.inline}>Catalog Generator -&nbsp;</Typography>
        <Typography
          variant="h5"
          className={cx(classes.inline, classes.link)}
          onClick={() => { setCreateCatalogDialogVisible(true); }}
        >
          Create Spec
        </Typography>
      </Box>
      <CatalogGenerator
        catalogSpecs={catalogs.catalogSpecs}
        pricesheets={pricesheets.pricesheets}
        onGenerate={(catalogSpecId, pricesheetId) => {
          generateCatalog({
            variables: {
              catalogSpecId,
              pricesheetId,
            },
          });
        }}
      />
      <Typography variant="h5" className={classes.header}>Catalog Spec Editor</Typography>
      <CatalogSpecList
        catalogSpecs={catalogs.catalogSpecs}
        onEdit={(catalogSpecId) => {
          history.push(`/catalogspec/${catalogSpecId}`);
        }}
      />
      <Typography variant="h5" className={classes.header}>Catalog List</Typography>
      <CatalogList
        catalogLogItems={catalogLogItems.getCatalogLog}
        onDownload={(url) => window.open(url)}
        onOpen={(url) => setOpenUrl(url)}
      />
      <CreateCatalogSpecDialog
        open={isCreateCatalogDialogVisible}
        onSubmit={(values) => {
          createCatalogSpec({
            variables: {
              label: values.label,
              name: values.name,
            },
          });
          setCreateCatalogDialogVisible(false);
        }}
      />
      { openUrl
        && (
        <CatalogPreviewDialog
          open={openUrl !== undefined}
          url={openUrl}
          onCancel={() => setOpenUrl(undefined)}
        />
        ) }
    </Page>
  );
};

export default CatalogsPage;
